import React from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import { Paper, Box } from "@material-ui/core";
import clsx from "clsx";

import useStyles from "./styles";

/**
 * CustomSideMenu - A reusable side menu container for overlays, drawers, or profile panels.
 *
 * Props:
 *   open: boolean - Whether the side menu is open/visible
 *   onClose: function - Callback for closing the menu
 *   children: ReactNode - Content to render inside the menu
 *   ...rest: any other children props
 */
function CustomSideMenu({ open, onClose, children, ...rest }) {
  const styles = useStyles();

  return ReactDOM.createPortal(
    <>
      <Paper className={clsx(styles.sideMenu, { [styles.hidden]: !open })}>
        <Box className={styles.sideMenuContent}>
          {typeof children === "function"
            ? children({ onClose, ...rest })
            : children}
        </Box>
      </Paper>
    </>,
    document.getElementById("portal-root")
  );
}

CustomSideMenu.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  children: PropTypes.node,
  className: PropTypes.string,
};

CustomSideMenu.defaultProps = {
  open: false,
  onClose: undefined,
  children: null,
  className: "",
};

export default CustomSideMenu;
